import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import img1 from './assets/ssalsoongi_up.png';
import img2 from './assets/ssalsoongi_down.png';
import InfiniteImages from './components/InfiniteImages';
import Claimbutton from './components/Claimbutton';
import Header from './components/Header';
import ssii_background from './assets/ssii_background.png';
import { CoinProvider } from './CoinContext';
import RaidButton from './components/RaidButton';
import CollectionButton from './components/CollectionButton';
import LeaderboardButton from './components/LeaderboardButton';
import SsalsoongIButton from './components/SsalsoongIButton';
import ShopButton from './components/ShopButton';
import MarketButton from './components/MarketButton';
import FaqButton from './components/FaqButton';
import EventButton from './components/EventButton';
import AnnouncementButton from './components/AnnouncementButton';
import UpdateNotification from './components/UpdateNotification';
import useAutoReloadByVersion from './hooks/useAutoReloadByVersion';
import CampPage from './pages/CampPage';
import CampPostPage from './pages/CampPostPage';
import CampWritePage from './pages/CampWritePage';
import CampMyPage from './pages/CampMyPage';

function HomePage() {
  useAutoReloadByVersion();
  const [coin, setCoin] = useState(0);
  const [resetTrigger, setResetTrigger] = useState(0);
  const images = [img1, img2];

  const handleClaim = (amount) => {
    setCoin(prev => prev + amount);
    setResetTrigger(rt => rt + 1);
  };

  const underMaintenance = false;
  if (underMaintenance) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#111',
        color: '#fff'
      }}>
        <h1>Server is under maintenance.(short!)</h1>
        <p>Please try again in a little while.</p>
      </div>
    );
  }

  return (
    <div className="game-root"
      style={{
        position: 'relative',
        maxWidth: '430px',
        width: 'min(100vw, 430px)',
        minHeight: '100vh',
        margin: '0 auto',
        background: `url(${ssii_background}) center center / cover no-repeat`,
        overflow: 'hidden',
        boxShadow: '0 6px 24px rgba(0,0,0,0.12)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Header coin={coin} />
      <UpdateNotification />
      <CollectionButton />
      <RaidButton />
      <LeaderboardButton />
      <SsalsoongIButton />
      <ShopButton />
      <MarketButton />
      <AnnouncementButton />
      <EventButton />
      <FaqButton />
      <InfiniteImages images={images} delay={400} width={60} height={60}>
        <Claimbutton onClaim={handleClaim} resetTrigger={resetTrigger} />
      </InfiniteImages>
    </div>
  );
}

function DomainRedirectModal() {
  const hostname = window.location.hostname;
  const isOldDomain = hostname === 'ssalsoongi.com' || hostname === 'www.ssalsoongi.com';

  if (!isOldDomain) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.5)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 18,
        padding: '32px 28px',
        maxWidth: 360,
        width: '90%',
        textAlign: 'center',
        boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
      }}>
        <div style={{ fontSize: 22, fontWeight: 700, color: '#222', marginBottom: 14 }}>
          URL Changed
        </div>
        <div style={{ fontSize: 15, color: '#555', lineHeight: 1.6, marginBottom: 22 }}>
          The login URL has been moved to<br />
          <strong style={{ color: '#21B6B4' }}>idle.mnwalk.com</strong><br /><br />
          Please use the new URL to log in.
        </div>
        <a
          href="https://idle.mnwalk.com"
          style={{
            display: 'inline-block',
            background: '#21B6B4',
            color: '#fff',
            padding: '12px 32px',
            borderRadius: 10,
            fontWeight: 600,
            fontSize: 16,
            textDecoration: 'none',
          }}
        >
          Go to idle.mnwalk.com
        </a>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <CoinProvider>
        <DomainRedirectModal />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/camp" element={<CampPage />} />
          <Route path="/camp/post/:id" element={<CampPostPage />} />
          <Route path="/camp/write" element={<CampWritePage />} />
          <Route path="/camp/edit/:id" element={<CampWritePage />} />
          <Route path="/camp/my" element={<CampMyPage />} />
        </Routes>
      </CoinProvider>
    </BrowserRouter>
  );
}

export default App;
